// Utility function to check if a value is likely a Unix timestamp
export const isUnixTimestamp = (value) => {
    // Check if it's a number or numeric string with 10-13 digits (seconds or milliseconds)
    if (value === null || value === undefined) return false;
    
    const strValue = String(value).trim();
    const numberValue = Number(strValue);
    
    // Must be a valid number
    if (isNaN(numberValue)) return false;
    
    // Check if it's a 10-digit (seconds) or 13-digit (milliseconds) timestamp
    // and falls within reasonable date range (1980-2050)
    if (strValue.length === 10) { // Seconds-based
        return numberValue >= 315532800 && numberValue <= 2524608000;
    } else if (strValue.length === 13) { // Milliseconds-based
        return numberValue >= 315532800000 && numberValue <= 2524608000000;
    }
    
    return false;
};

// Format Unix timestamp for display
export const formatTimestamp = (timestamp) => {
    let date;
    
    // Convert to number if it's a string
    const numTimestamp = Number(timestamp);
    
    // Check if it's seconds or milliseconds format based on length
    if (String(timestamp).length === 10) {
        date = new Date(numTimestamp * 1000); // Convert seconds to milliseconds
    } else {
        date = new Date(numTimestamp); // Already in milliseconds
    }
    
    return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    }).replace(',', '');
};